import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import {
  stepDescriptionClassName,
  stepHeadingClassName,
} from "@/components/Welcome/AuthenticatorSetup/authenticator.utils";
import { useManualSetupDefault } from "@/hooks/useManualSetupDefault";
import { useDisplayTwoFactorAuthenticationData } from "@/services/auth";

import { TwoFactorChangeAuthQRCode } from "./TwoFactorChangeAuthQRCode";
import { TwoFactorManualQrCodeField } from "./TwoFactorManualQrCodeField";

// This component displays the current QR code again
// for users in their 2FA management page.
export const TwoFactorQRCodeSection = () => {
  const { t } = useTranslation();
  const { mutate, data } = useDisplayTwoFactorAuthenticationData();
  const [showManualSetup, setShowManualSetup] = useManualSetupDefault();

  useEffect(() => {
    mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <h2 className={stepHeadingClassName}>
        {t("portal:user-account.security.2fa.qrCode.title")}
      </h2>
      <p className={stepDescriptionClassName}>
        {t("portal:user-account.security.2fa.qrCode.description")}
      </p>
      <div className="flex flex-col items-center gap-2">
        {showManualSetup ? (
          <TwoFactorManualQrCodeField manualCode={data?.manualCode} />
        ) : (
          <div className="flex w-full justify-center rounded-md bg-surface-tertiary p-4">
            <TwoFactorChangeAuthQRCode qrCodeData={data?.qrCodeUri} />
          </div>
        )}
        <Button
          variant="tertiary"
          size="sm"
          type="button"
          onClick={() => setShowManualSetup((prev) => !prev)}
        >
          {t(
            showManualSetup
              ? "portal:authenticator.app.setup.step1.show-qr-code"
              : "portal:authenticator.app.setup.step1.enter-key-manually",
          )}
        </Button>
      </div>
    </div>
  );
};
